import filterUrlHelper from '../../helpers/filter-url'

export default {
  setPoints(state, points) {
    state.points = points
  },
  setDetailedLocations(state, detailedLocations) {
    state.detailedLocations = detailedLocations
  },
  setPage(state, page) {
    state.pagination.page = page
  },
  setPaginationCounts(state, meta) {
    state.pagination.perPage = meta.perPage
    state.pagination.totalCount = meta.count
    state.pagination.totalPages = meta.totalPages
  },
  setPointsInitiallyLoaded(state) {
    state.pointsInitiallyLoaded = true
  },
  setIsLoadingList(state, isLoading) {
    state.isLoadingList = isLoading
  },

  setOptionsFromUrlAndFilters(state, filters) {
    const urlState = filterUrlHelper.currentStateFromUrl()
    if (urlState) {
      state.pagination.page = urlState.pagination.currentPage || 1
    }

    state.filters = [
      ...filters,
      ...(urlState ? urlState.filters : [])
    ]
  },

  setUrlFilterKeys(state, keys) {
    state.urlFilterKeys = keys
  },

  setAdditionalUrlKeysIncludedInItemPageUrls(state, keys) {
    state.additionalUrlKeysIncludedInItemPageUrls = keys
  },

  setAdditionalParamsIncludedInEventUrls(state, params) {
    state.additionalParamsIncludedInEventUrls = params
  },

  setEventCreationAllowed(state, eventCreationAllowed) {
    state.eventCreationAllowed = eventCreationAllowed
  },

  setGroupCreationAllowed(state, groupCreationAllowed) {
    state.groupCreationAllowed = groupCreationAllowed
  },

  setEventCreationRequiresSearchedLocation(state, eventCreationRequiresSearchedLocation) {
    state.eventCreationRequiresSearchedLocation = eventCreationRequiresSearchedLocation
  },

  setForceCreateEventButtonHidden(state, forceCreateEventButtonHidden) {
    state.forceCreateEventButtonHidden = forceCreateEventButtonHidden
  },

  setFilterOptions(state, filterOptions) {
    state.filterOptions = filterOptions
  },

  setMultipleEventsPerConstituncyAllowed(state, multipleEventsPerConstituencyAllowed) {
    state.multipleEventsPerConstituencyAllowed = multipleEventsPerConstituencyAllowed
  },

  setSearchedLocation(state, searchedLocation) {
    state.searchedLocation = searchedLocation
  },

  setSearchStrategy(state, searchStrategy) {
    state.searchStrategy = searchStrategy
  }
}
